module.exports = __webpack_public_path__ + "static/img/倚靠人车识别.bd74021c.png";